import { SourcingService } from 'api-clients/monolith';

/** Pusher events Hire triggers on a posting batch's private channel. */
export const POSTING_ITEM_EVENTS = ['item_settled', 'item_queued'] as const;
export const POSTING_BATCH_COMPLETED_EVENT = 'completed';
export const POSTING_BATCH_EVENTS = [
  ...POSTING_ITEM_EVENTS,
  POSTING_BATCH_COMPLETED_EVENT,
] as const;

export const POSTING_BATCH_CHANNEL_PREFIX = 'private-sourcing-posting-batch-';

export function getPostingBatch(postingBatchId: string) {
  return SourcingService.getInternalApiSourcingPostingBatches(postingBatchId);
}

export function retryPostingItem(itemId: number) {
  return SourcingService.postInternalApiSourcingPostingItemsRetry(itemId);
}
